import { DashboardInProgress } from "../DashboardInProgress";
import { PopularityMeasuringsWidget } from "./widgets/popularityMeasurings";
import { StatisticsWidget } from "./widgets/statistics";

export interface DashboardProps {}
export const Dashboard = ({}: DashboardProps) => {
    return (
        <>
            <StatisticsWidget />
            <PopularityMeasuringsWidget />
            <DashboardInProgress />
        </>
    );
};
